<!-- @format -->

<ng-container *transloco="let t">
  <fudis-dialog [size]="'xl'">
    <fudis-heading [level]="2">{{ resolveTitle(data?.externalAttainedStudy?.learningOpportunitySpecification) }} </fudis-heading>
    @if (data?.externalAttainedStudy?.externalIssuerId | externalIssuer | async; as externalIssuer) {
      <fudis-dialog-content>
        <fudis-grid [rowGap]="'md'">
          <fudis-grid-item>
            <fudis-body-text [variant]="'md-light'">{{ t("EMREX_ATTAINMENT_DIALOG.GUIDANCE") }}</fudis-body-text>
          </fudis-grid-item>
          <fudis-grid-item>
            <fudis-grid [columns]="{ md: 1, lg: 2 }">
              <fudis-dl>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.STUDENT_NAME')"> </fudis-dt>
                  <fudis-dd>
                    @if (resolveFullName(data?.externalAttainedStudy?.learner); as fullName) {
                      {{ fullName }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.ISCED_CODE')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.iscedCode; as iscedCode) {
                      {{ iscedCode }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.ISSUER.IDENTIFIER')" />
                  @if (externalIssuer?.identifiers?.length > 0) {
                    @for (identifier of externalIssuer?.identifiers; track identifier) {
                      <fudis-dd>
                        {{ identifier.value }}
                      </fudis-dd>
                    }
                  }
                  @if (!externalIssuer?.identifiers?.length) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.ISSUER.URL')" />
                  <fudis-dd>
                    @if (externalIssuer?.url; as url) {
                      <a fudisLink [title]="url" [href]="url" [external]="true"></a>
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.CREDIT')" />
                  @if (data?.externalAttainedStudy?.learningOpportunityInstance?.credit?.length > 0) {
                    @for (credit of data?.externalAttainedStudy?.learningOpportunityInstance?.credit; track credit) {
                      <fudis-dd>
                        {{ t("EMREX_ATTAINMENT_DIALOG.CREDITS", { credits: credit.value }) }}
                      </fudis-dd>
                    }
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunityInstance?.credit?.length) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.LANGUAGE_OF_INSTRUCTIONS')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.languageOfInstruction; as instructions) {
                      {{ instructions | codeLocalizedName | async }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.GRADING_SCALE')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.gradingScheme; as gradingScheme) {
                      {{ gradingScheme | localizedString }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.SUBJECT_AREA')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.subjectArea; as subjectArea) {
                      {{ subjectArea }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.URL')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.url; as url) {
                      <a fudisLink [title]="url" [href]="url" [external]="true"></a>
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.DESCRIPTION_HTML')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.descriptionHtml; as description) {
                      {{ description }}
                      <!-- TODO: backend should have sanitized markup string before viewing markup here? -->
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.START')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.start; as start) {
                      {{ start }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.STATUS')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.status; as status) {
                      {{ status }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.LEVEL')" />
                  @if (data?.externalAttainedStudy?.learningOpportunityInstance?.level?.length > 0) {
                    @for (level of data?.externalAttainedStudy?.learningOpportunityInstance?.level; track level) {
                      <fudis-dd>
                        {{ level.type }}
                        <!-- TODO: what should we view here? -->
                      </fudis-dd>
                    }
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunityInstance?.credit?.length) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.GROUPING')" />
                  <fudis-dd>
                    <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    <!-- TODO: missing field ELMO.LearningOpportunityInstance.grouping -->
                  </fudis-dd>
                </fudis-dl-item>
              </fudis-dl>
              <fudis-dl>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.TITLE')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.title; as title) {
                      {{ title | localizedString }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.ISSUER.TITLE')" />
                  @if (externalIssuer?.title) {
                    <fudis-dd>
                      {{ externalIssuer.title | localizedString }}
                    </fudis-dd>
                  }
                  @if (!externalIssuer?.title) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.ISSUER.COUNTRY')" />
                  <fudis-dd>
                    @if (externalIssuer.countryUrn) {
                      {{ externalIssuer.countryUrn | codeLocalizedName | async }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.DATE')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.date; as date) {
                      {{ date | localDateFormat }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.ENGAGEMENT_HOURS')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.engagementHours; as engagementHours) {
                      {{ t("EMREX_ATTAINMENT_DIALOG.ENGAGEMENT_HOURS", { engagementHours }) }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.RESULT_LABEL')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunityInstance?.resultLabel; as resultLabel) {
                      {{ resultLabel }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.SHORTENED_GRADING')" />
                  @if (data?.externalAttainedStudy?.learningOpportunityInstance?.shortenedGrading; as shortenedGrading) {
                    <fudis-dd
                      [contentText]="t('EMREX_ATTAINMENT_DIALOG.PERCENTAGE_LOWER', { percentage: shortenedGrading.percentageLowe })" />
                    <fudis-dd
                      [contentText]="t('EMREX_ATTAINMENT_DIALOG.PERCENTAGE_EQUAL', { percentage: shortenedGrading.percentageEqual })" />
                    <fudis-dd
                      [contentText]="t('EMREX_ATTAINMENT_DIALOG.PERCENTAGE_HIGHER', { percentage: shortenedGrading.percentageHigher })" />
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunityInstance?.shortenedGrading) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.TYPE')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.type; as type) {
                      {{ type }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.DESCRIPTION')" />
                  <fudis-dd>
                    @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.description; as description) {
                      {{ description }}
                    } @else {
                      {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
                    }
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.IDENTIFIER')" />
                  @if (data?.externalAttainedStudy?.learningOpportunitySpecification?.identifiers?.length > 0) {
                    @for (identifier of data?.externalAttainedStudy?.learningOpportunitySpecification?.identifiers; track identifier) {
                      <fudis-dd>
                        {{ identifier.value }}
                      </fudis-dd>
                    }
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunitySpecification?.identifiers?.length) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.IDENTIFIER')" />
                  @if (data?.externalAttainedStudy?.learningOpportunityInstance?.identifiers?.length > 0) {
                    @for (identifier of data?.externalAttainedStudy?.learningOpportunityInstance?.identifiers; track identifier) {
                      <fudis-dd>
                        {{ identifier.value }}
                      </fudis-dd>
                    }
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunityInstance?.identifiers?.length) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.ACADEMIC_TERM')" />
                  <fudis-dd>
                    <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    <!-- TODO: missing field ELMO.LearningOpportunityInstance.academicTerm -->
                  </fudis-dd>
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_INSTANCE.RESULT_DISTRIBUTION')" />
                  @if (data?.externalAttainedStudy?.learningOpportunityInstance?.resultDistribution; as resultDistribution) {
                    @for (category of resultDistribution?.category; track category) {
                      <fudis-dd> {{ category.label }}: {{ category.count }} </fudis-dd>
                    }
                  }
                  @if (!data?.externalAttainedStudy?.learningOpportunityInstance?.resultDistribution) {
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                    </fudis-dd>
                  }
                </fudis-dl-item>
                <fudis-dl-item>
                  <fudis-dt [contentText]="t('EMREX_ATTAINMENT_DIALOG.LEARNING_OPPORTUNITY_SPECIFICATION.HAS_PART')" />
                  <fudis-dd>
                    <fudis-dd>
                      <ng-container [ngTemplateOutlet]="emptyStateTpl" />
                      <!-- TODO: missing field ELMOLearningOpportunitySpecification.hasPart -->
                    </fudis-dd>
                  </fudis-dd>
                </fudis-dl-item>
              </fudis-dl>
            </fudis-grid>
          </fudis-grid-item>
        </fudis-grid>
      </fudis-dialog-content>
    }
    <fudis-dialog-actions>
      <fudis-button fudisDialogClose [label]="t('BUTTON.CLOSE')" />
    </fudis-dialog-actions>
  </fudis-dialog>

  <ng-template #emptyStateTpl>
    {{ t("EMREX_ATTAINMENT_DIALOG.EMPTY_STATE") }}
  </ng-template>
</ng-container>
